import React, { FC, useState } from "react";
import { FormControl, IconButton, Input, InputAdornment, InputLabel } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

interface PasswordInput {
  onChange: (str: string) => void;
  label?: string;
  variant?: "standard" | "outlined" | "filled";
  id?: string;
}

const PasswordInput: FC<PasswordInput> = ({ onChange, label = "Пароль", id = "password", variant = "standart" }) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <FormControl sx={{ mt: 1 }} fullWidth size="small" variant={variant}>
      <InputLabel htmlFor="passwordInput">{label}</InputLabel>
      <Input
        type={showPassword ? "text" : "password"}
        onChange={(e) => {
          onChange(e.target.value);
        }}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              id={id}
              onClick={() => setShowPassword(!showPassword)}
              //   onMouseDown={handleMouseDownPassword}
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        }
      />
    </FormControl>
  );
};

export default PasswordInput;
